import * as actions from "actions";
import { browserHistory } from "react-router";
import {
  getClientCredential,
  updatePaymentStatus,
  getOrders,
  getOrderLines,
  getMerchantSignature,
  generateAndSendVcs,
  getAllOrders,
  getAllBankTransfers,
  createPayment,
  getOrdersByStatusCriteria,
  getAllUsers,
  getStatistiques,
  paypalCallback,
  getCreditNotes,
  refundCreditNote,
  getOrdersNotPayed,
  getTransfersNotAssosiated,
  getSortedOrders,
  validatePayment,
  getAllUserOrders,
  getSortedTransfers,
  validatePaymentTransfersToOrder,
  displayDocument,
  validateIban,
  fetchErrorCallbackURL,
  getMainIban,
  fetchModificationURL,
  getOgoneKey,
  fetchIssuerPayments,
  getUserCreditNoteInformation,
  getLatestIban,
  saveIban,
  fetchBackToURL,
  ignoreBankTransfer
} from "TamtamAPI";
import { pushSourceToken } from "utils";
import {
  getLocalStorageCoda,
  setLocalStorageCoda,
  getLocalStorageOrder,
  setLocalStorageOrder
} from "PaymentAPI";
import * as api from "../../api";

export const changePaymentStatus = paymentId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.updatePaymentStatus(
        updatePaymentStatus(token, paymentId).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const documentDisplay = (documentIdId, type) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { token } = getState().auth;
      displayDocument(token, documentIdId, type);
      resolve(); // Resolve the promise immediately after initiating the display
    }).then(() => {
      return 'success'; // Resolve with success
    }).catch(error => {
      return 'error'; // Reject with error
    });
  };
};

export const fetchOrders = orderId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.getOrders(
        getOrders(token, orderId).then(
          res => {
            try {
              setLocalStorageOrder(res.data.data);
            } catch (e) {}
            return res.data.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchOrderLines = orderId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.getOrderLines(
        getOrderLines(token, orderId).then(
          res => {
            return res.data.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchAdyenKey = (
  orderId,
  sessionValidity,
  currencyCode,
  paymentAmount
) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.getMerchantSignature(
        getMerchantSignature(
          token,
          orderId,
          sessionValidity,
          currencyCode,
          paymentAmount
        ).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const getErrorCallbackURL = orderID => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.fetchErrorCallbackURL(
        fetchErrorCallbackURL(token, orderID).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const getModificationURL = orderID => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.fetchModificationURL(
        fetchModificationURL(token, orderID).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const getBackToURL = orderID => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.fetchBackToURL(
        fetchBackToURL(token, orderID).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchAllOrders = (searchValue, selectedValue, currentClient) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const { pageSize, paginationPage } = getState().allOrders;
    return dispatch(
      actions.getAllOrders(
        getAllOrders(
          token,
          pageSize,
          paginationPage,
          searchValue,
          selectedValue,
          currentClient
        ).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchOrdersByUser = (
  idUser,
  clientID,
  searchValue,
  selectedValue
) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const { pageSize, paginationPage } = getState().allUserOrders;
    return dispatch(
      actions.getAllUserOrders(
        getAllUserOrders(
          token,
          idUser,
          clientID,
          pageSize,
          paginationPage,
          searchValue,
          selectedValue
        ).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchAllBankTransfers = (searchValue, selectedValue) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const { pageSize, paginationPage } = getState().allBankTransfers;
    return dispatch(
      actions.getAllBankTransfers(
        getAllBankTransfers(
          token,
          pageSize,
          paginationPage,
          searchValue,
          selectedValue
        ).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const createPayments = (file, issuerId = null) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.createPayments(
        createPayment(token, file, issuerId).then(
          res => {
            setLocalStorageCoda(res.data.data);
            return res.data.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchAllUsers = () => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.getAllUsers(
        getAllUsers(token).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchStatistiques = () => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.getStatistiques(
        getStatistiques(token).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const paypalPayment = (orderID, paypalPayment) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.paypalCallback(
        paypalCallback(token, orderID, paypalPayment).then(
          res => {
            return res.data.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchAllCreditNotes = (
  searchValue,
  selectedValue,
  currentClient
) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const { pageSize, paginationPage } = getState().creditNotes;
    return dispatch(
      actions.getCreditNotes(
        getCreditNotes(
          token,
          pageSize,
          paginationPage,
          searchValue,
          selectedValue,
          currentClient
        ).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchOrdersNotPayed = (
  amount = null,
  field = null,
  currentClient
) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const { paginationPage } = getState().ordersNotPayed;
    return dispatch(
      actions.fetchOrderNotPayed(
        getOrdersNotPayed(token, amount, field, currentClient, paginationPage)
      )
    );
  };
};

export const changeCreditNoteStatusToRefunded = (
  creditNoteId,
  refundDate,
  refundType,
  note
) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.refundCreditNote(
        refundCreditNote(
          token,
          creditNoteId,
          refundDate,
          refundType,
          note
        ).then(
          res => {
            return res.data.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchTransfersNotAssociated = (orderId = null, field = null) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const { paginationPage } = getState().transfersNotAssociated;
    return dispatch(
      actions.fetchTransfersNotAssociated(
        getTransfersNotAssosiated(token, orderId, field, paginationPage)
      )
    );
  };
};

export const fetchSortedOrders = (amount, field) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.sortedOrders(
        getSortedOrders(token, amount, field).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};
export const validatePaymentTransfer = (data, params) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.validatePayment(
        validatePayment(token, data, params).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const validatePaymentOrder = (data, params) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.validatePaymentOrder(
        validatePaymentTransfersToOrder(token, data, params).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const saveIbanSettings = () => {
  return (dispatch, getState) => {
    const { token, selectedIban } = getState().auth;
    let clientId = getState().auth.currentClient.id;
    return dispatch(
      actions.validateIban(
        validateIban(token, clientId, selectedIban).then(
          res => {
            return res;
          },
          err => err
        )
      )
    );
  };
};

export const fetchMainIban = issuerId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.getMainIban(
        getMainIban(token, issuerId).then(
          res => {
            return res.data.data;
          },
          err => err
        )
      )
    );
  };
};

export const fetchOgoneKey = (
  orderId,
  amount,
  language,
  comment,
  customerName,
  email,
  cancelURL,
  acceptURL
) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.getOgoneKey(
        getOgoneKey(
          token,
          orderId,
          amount,
          language,
          comment,
          customerName,
          email,
          cancelURL,
          acceptURL
        ).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const getUserCreditNoteInformations = cacheId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.fetchCreditNoteData(getUserCreditNoteInformation(token, cacheId))
    );
  };
};

export const fetchLatestIban = userId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.getLatestIban(
        getLatestIban(token, userId).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const saveIbanCreditNote = (id, iban) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(actions.saveIban(saveIban(token, id, iban)));
  };
};

export const updateBankTransfer = bankTransfers => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.ignoreBankTransfer(
        ignoreBankTransfer(token, bankTransfers).then(
          res => {
            return res.data;
          },
          err => err
        )
      )
    );
  };
};

export const saveRefundDetails = (
  creditNoteId,
  firstName,
  lastName,
  rib,
  bank
) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.saveRefundDetails(
        api.saveRefundDetails(
          token,
          creditNoteId,
          firstName,
          lastName,
          rib,
          bank
        )
      )
    );
  };
};

export const getRefundDetails = creditNoteId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.getRefundDetails(api.getRefundDetails(token, creditNoteId))
    );
  };
};



// WEBPACK FOOTER //
// ./app/actions/thunks/payment.js